<script setup>
  import Hft_SectionWrapper from '@/components/microsites/HeadingForTomorrow/components/Hft_SectionWrapper.vue'
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/ScrollTrigger'
  import { onMounted } from 'vue'
  gsap.registerPlugin(ScrollTrigger)
  const box1Items = [
    {
      title: 'Skill Sequence',
      text: 'Set up multiple skills to cast with a single button press using the new Skill Sequence feature!',
    },
    {
      title: 'Sol Erda Conversion',
      text: 'Get more out of your Sol Erda, converting them into Faint Sol Erda Energy for storage, or the new HEXA Booster!',
    },
    {
      title: 'Arcane River Quest Improvements',
      text: 'Sail down the Arcane River with new quests and a revamped flow to allow repeat visitors to skip ahead!',
    },
    {
      title: 'More Arcane Symbols from Special Content',
      text: 'Get Arcane Power even faster, with each run of Arcane River Special Content rewarding more than double the Arcane Symbols!',
    },
    {
      title: 'Skill Revamps for all Jobs',
      text: 'Get ready for major changes to all Jobs!',
    },
    {
      title: 'World Map Teleport',
      text: 'Teleport around Maple World from the world map with ease, and use new Town Portals to quickly reach major cities!',
    },
    {
      title: 'UI Improvements',
      text: 'UI Revamps for the Quest, World Map, and Mini-map screens make them better looking and easier to use!',
    },
    {
      title: 'Genesis Weapon Liberation Improvements',
      text: 'Instead of needing to defeat the Genesis Crux, Liberation is now easier by collecting Traces of Darkness from defeating the Black Mage or his Commanders!',
    },
    {
      title: 'Improved Monster Park',
      text: 'Get Monster Park medals faster and more EXP from the now-weekly Monster Park Extreme!',
    },
  ]
  onMounted(() => {
    if (window.innerWidth >= 1024) {
      const tl_box1 = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-more-chars',
          start: 'top 60%', // when the top of the element hits 80% of the viewport height
          toggleActions: 'play none none none',
        },
      })
      tl_box1
        .fromTo(
          '.m-headingForT-more-chars__char--1',
          { opacity: 0 },
          { opacity: 1, delay: 1, duration: 1.5, ease: 'power2.out' },
          '<'
        )
        .fromTo(
          '.m-headingForT-more-chars__char--2',
          { opacity: 0 },
          { opacity: 1, duration: 1.5, ease: 'power2.out' },
          '<'
        )
      tl_box1
        .fromTo(
          '.m-headingForT-more-chars__top-titles',
          { scale: 1.15, opacity: 0 },
          { scale: 1, opacity: 1, duration: 1, ease: 'power2.out' },
          '<'
        )
        .fromTo(
          '.m-headingForT-more-chars-box1',
          { scale: 1.1, opacity: 0 },
          { scale: 1, opacity: 1, duration: 1, ease: 'power2.out' },
          '<'
        )
      for (let i = 1; i <= 9; i++) {
        tl_box1.fromTo(
          `.m-headingForT-more-chars-box1-item--${i}`,
          { scale: 1.1, opacity: 0 },
          { scale: 1, opacity: 1, delay: 0.25, duration: 1, ease: 'power2.out' },
          '<' // sync start with previous animation
        )
      }

      const tl_box2 = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-more-chars-box2',
          start: 'top 60%', // when the top of the element hits 80% of the viewport height
          toggleActions: 'play none none none',
        },
      })
      tl_box2.fromTo(
        '.m-headingForT-more-chars-box2',
        { scale: 1.15, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1, ease: 'power2.out' },
        '<'
      )
      tl_box2.fromTo(
        '.m-headingForT-more-chars__char--3',
        { scale: 1.15, opacity: 0 },
        { scale: 1, opacity: 1, delay: 0.3, duration: 1, ease: 'power2.out' },
        '<'
      )
      tl_box2.fromTo(
        '.m-headingForT-more-chars__char--4',
        { scale: 1, opacity: 0 },
        { scale: 1, opacity: 1, delay: 0.3, duration: 1, ease: 'power2.out' },
        '<'
      )

      const tl_box3 = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-more-chars-box3',
          start: 'top 60%', // when the top of the element hits 80% of the viewport height
          toggleActions: 'play none none none',
        },
      })
      tl_box3.fromTo(
        '.m-headingForT-more-chars-box3',
        { scale: 1.1, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1, ease: 'power2.out' },
        '<'
      )
    }
  })
</script>

<template>
  <div class="m-headingForT-more-chars">
    <Hft_SectionWrapper class="m-headingForT-more-chars__sectionWrapper">
      <div class="m-headingForT-more-chars__overal-content">
        <div class="m-headingForT-more-chars__char m-headingForT-more-chars__char--1"></div>
        <div class="m-headingForT-more-chars__char m-headingForT-more-chars__char--2"></div>
        <!-- <div class="m-headingForT-more-chars__char m-headingForT-more-chars__char--3"></div>
        <div class="m-headingForT-more-chars__char m-headingForT-more-chars__char--4"></div> -->
        <div class="m-headingForT-more-chars__top-titles">
          <div class="m-headingForT__title">More Changes for a Better Maple!</div>
          <div class="m-headingForT__sub-title">Available Now!</div>
        </div>

        <div class="m-headingForT-more-chars-box1">
          <div
            v-for="(item, index) in box1Items"
            :key="`m-headingForT-more-chars-box1-item--${index}`"
            class="m-headingForT-more-chars-box1-item"
            :class="`m-headingForT-more-chars-box1-item--${index + 1}`"
          >
            <div class="m-headingForT-more-chars-box1-item__img"></div>
            <div class="m-headingForT-more-chars-box1-item__text-wrapper">
              <div class="m-headingForT-more-chars-box1-item__title">{{ item.title }}</div>
              <div class="m-headingForT-more-chars-box1-item__text">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="m-headingForT-more-chars-box2">
          <div class="m-headingForT-more-chars-box2__title">
            <div class="m-headingForT__title">Coming soon in v.261</div>
          </div>

          <Hft_ContentBox>
            <div class="m-headingForT-more-chars-box2__text">
              More arrives in July, including special events you don't want to miss!
              <br /><br /><span>6th Job Mastery Nodes:</span> Nodes #3 and #4 become available, upgrading more of your
              classic skills with even greater power! <br /><br /><span>MAPLESTORY X DAVE THE DIVER:</span> Help Dave
              and his friends who are stranded in Maple World! <br /><br /><span>Ride or Die:</span> Kazax’s sinister
              scheme last winter was only the beginning. His minions are coming back with new upgrades, and you can earn
              exclusive rewards by defeating them! <br /><br />And More!
            </div>
          </Hft_ContentBox>
        </div> -->

        <!-- <div class="m-headingForT-more-chars-box3">
          <div class="m-headingForT__title">Hit the Road Event!</div>
          <div class="m-headingForT__sub-title">Available Now!</div>
          <Hft_ContentBox>
            <div class="m-headingForT-more-chars-box3__text">
              Embrace a wealth of prizes coming to you just for hunting monsters through June 10 (UTC)! Collect VIP
              Boosters, Experience Nodestones, Sol Erda/Fragment Selector Coupons, and more!
            </div>
            <div class="m-headingForT-more-chars-box3__img"></div>
          </Hft_ContentBox>
        </div> -->
        <!-- <a
          v-ga-event="'Learn More Button'"
          href="https://www.nexon.com/maplestory/news/events/27058/hit-the-road-event"
          target="_blank"
          ><Hft_Btn class="m-headingForT-more-chars__link-btn"
        /></a> -->
      </div>
    </Hft_SectionWrapper>
  </div>
</template>

<style lang="scss" scoped>
  @use '@/assets/scss/microsites/headingfortomorrow/fonts.scss' as *;
  @use '@/assets/scss/microsites/headingfortomorrow/variables.scss' as *;

  .m-headingForT-more-chars {
    background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/bg.jpg') no-repeat center top / 100%
      auto;
    text-align: center;
  }
  .m-headingForT-more-chars__overal-content {
    max-width: 100%;
    overflow: hidden;
  }
  .m-headingForT-more-chars__char {
    position: absolute;
    background: no-repeat center top / 100% auto;
  }
  .m-headingForT-more-chars__char--1 {
    width: 22.8vw;
    height: 13.5vw;
    left: 15.9vw;
    top: 3.7vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/deco-char-1.png') no-repeat center
      top / 100% auto;
  }
  .m-headingForT-more-chars__char--2 {
    width: 22.8vw;
    height: 13.5vw;
    right: 18.8vw;
    top: 3.7vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/deco-char-2.png') no-repeat center
      top / 100% auto;
  }
  @keyframes m-headingForT-more-chars__char3 {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-3vw); /* move up */
    }
    100% {
      transform: translateY(0);
    }
  }
  .m-headingForT-more-chars__char--3 {
    width: 27.8vw;
    height: 33.5vw;
    left: 3.2vw;
    top: 113vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/deco-char-3-1.png') no-repeat center
      top / 100% auto;
    z-index: 2;
    animation: m-headingForT-more-chars__char3 3s ease-in-out infinite;
  }

  .m-headingForT-more-chars__char--4 {
    width: 33.8vw;
    height: 24.5vw;
    right: 1.5vw;
    top: 127.5vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/deco-char-4.png') no-repeat center
      top / 100% auto;
    z-index: 2;
  }
  .m-headingForT-more-chars__sectionWrapper {
    padding-bottom: 6.5vw;
  }

  .m-headingForT-more-chars__top-titles {
    width: 30vw;
    margin: 0 auto 2.3vw;
    .m-headingForT__title,
    .m-headingForT__sub-title {
      text-shadow: 2px 2px 4px #191b3d, 2px 2px 4px #191b3d, 2px 2px 4px #191b3d, 2px 2px 4px #191b3d,
        2px 2px 4px #191b3d;
    }
  }

  .m-headingForT-more-chars-box1 {
    width: 93.5vw;
    height: 79vw;
    padding: 2.7vw;
    margin: 0 auto 2vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box-bg.png') no-repeat
      center top / 100% auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 1vw;
    position: relative;
  }
  .m-headingForT-more-chars-box1-item {
    padding: 2.2vw;
    text-align: left;
    background: #191b3d;
    border: 1px solid #80d8ff;
    box-shadow: inset 0 0 15px rgba(#80d8ff, 0.7), 0 0 15px rgba(#80d8ff, 0.7);
    position: relative;
  }
  .m-headingForT-more-chars-box1-item__title {
    color: #80d8ff;
    font-size: 1.3vw;
    margin-bottom: 0.3vw;
    text-transform: uppercase;
  }
  .m-headingForT-more-chars-box1-item__text {
    font-size: 1vw;
    line-height: 1.2vw;
  }
  .m-headingForT-more-chars-box1-item__img {
    position: absolute;
    content: '';
  }
  .m-headingForT-more-chars-box1-item__text-wrapper {
    position: relative;
    z-index: 1;
  }

  .m-headingForT-more-chars-box1-item--1 {
    width: 57vw;
    height: 20vw;
    border-top-left-radius: 13px;
    .m-headingForT-more-chars-box1-item__img {
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box1-img.png')
        no-repeat right bottom / 87% auto;
    }
    .m-headingForT-more-chars-box1-item__text-wrapper {
      width: 16vw;
    }
  }

  .m-headingForT-more-chars-box1-item--2 {
    width: 28vw;
    padding: 3vw 3.6vw;
    .m-headingForT-more-chars-box1-item__img {
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box2-img.png')
        no-repeat center bottom / 75% auto;
    }
    .m-headingForT-more-chars-box1-item__text-wrapper {
      width: 20vw;
    }
  }

  .m-headingForT-more-chars-box1-item--3 {
    width: 28vw;
    .m-headingForT-more-chars-box1-item__text-wrapper {
      width: 100%;
    }
  }

  .m-headingForT-more-chars-box1-item--4 {
    width: 28vw;
    .m-headingForT-more-chars-box1-item__text-wrapper {
      width: 100%;
    }
  }

  .m-headingForT-more-chars-box1-item--5 {
    width: 28vw;
    .m-headingForT-more-chars-box1-item__img {
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box5-img.png')
        no-repeat right bottom / 70% auto;
    }
    .m-headingForT-more-chars-box1-item__text-wrapper {
      width: 13vw;
    }
  }

  .m-headingForT-more-chars-box1-item--6 {
    width: 42.4vw;
    height: 21vw;
    .m-headingForT-more-chars-box1-item__img {
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box6-img.png')
        no-repeat center bottom / 75% auto;
    }
    .m-headingForT-more-chars-box1-item__text-wrapper {
      width: 31.5vw;
      margin: 0 auto;
    }
  }
  .m-headingForT-more-chars-box1-item--7 {
    width: 42.4vw;

    .m-headingForT-more-chars-box1-item__img {
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box7-img.png')
        no-repeat center bottom 2vw / 89% auto;
    }
    .m-headingForT-more-chars-box1-item__text-wrapper {
      width: 19vw;
    }
  }

  .m-headingForT-more-chars-box1-item--8 {
    width: 28vw;

    .m-headingForT-more-chars-box1-item__img {
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box8-img.png')
        no-repeat right bottom / 44% auto;
    }
    .m-headingForT-more-chars-box1-item__text-wrapper {
      width: 12vw;
    }
  }

  .m-headingForT-more-chars-box1-item--9 {
    width: 57vw;

    .m-headingForT-more-chars-box1-item__img {
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box9-img.png')
        no-repeat right 1vw bottom / 94.5% auto;
    }
    .m-headingForT-more-chars-box1-item__text-wrapper {
      width: 25vw;
    }
  }

  .m-headingForT-more-chars-box2 {
    margin-bottom: 23vw;
  }

  .m-headingForT-more-chars-box2__text {
    width: 41vw;
    margin: 0 auto;
    span {
      color: #80d8ff;
    }
  }

  .m-headingForT-more-chars-box3__text {
    margin-bottom: 1.3vw;
  }
  .m-headingForT-more-chars-box3__img {
    width: 44vw;
    height: 20vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box3-img.png') no-repeat right 1vw
      bottom / 94.5% auto;
  }

  .m-headingForT-more-chars__link-btn {
    margin-top: -1vw;
  }

  .tablet {
    .m-headingForT-more-chars {
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/bg-tablet.jpg') no-repeat center
        top / 100% auto;
      text-align: center;
      :deep(.m-headingForT-section) {
        padding: 8.7vw 0 16vw;
      }
    }

    .m-headingForT-more-chars__top-titles {
      width: 57vw;
      margin-bottom: 5vw;
      .m-headingForT__title {
        margin-bottom: 4vw;
      }
    }
    .m-headingForT-more-chars__char--1 {
      width: 44.8vw;
      height: 40.5vw;
      left: 0;
      top: 4vw;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/deco-char-1.png') no-repeat left -16vw
        top / 100% auto;
    }
    .m-headingForT-more-chars__char--2 {
      width: 52.8vw;
      height: 38.5vw;
      right: 0;
      top: 0.7vw;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/deco-char-2.png') no-repeat right -16.5vw
        top / 100% auto;
    }
    .m-headingForT-more-chars__char--3 {
      width: 33.8vw;
      height: 38.5vw;
      z-index: 0;
      top: 217vw;
      left: 3.2vw;
    }
    .m-headingForT-more-chars__char--4 {
      width: 23.8vw;
      height: 17.5vw;
      right: 1.5vw;
      top: 228vw;
    }

    .m-headingForT-more-chars-box1 {
      width: 97vw;
      height: 173vw;
      padding: 3.5vw 3.7vw 3.7vw 2.7vw;
      margin: 0 auto 4vw;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box-bg-tablet.png')
        no-repeat center top / 100% auto;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      align-content: flex-start;
      gap: 1.4vw;
      position: relative;
    }
    .m-headingForT-more-chars-box1-item {
      padding: 4vw;
    }
    .m-headingForT-more-chars-box1-item__title {
      font-size: 2.3vw;
      text-transform: uppercase;
    }
    .m-headingForT-more-chars-box1-item__text {
      font-size: 1.9vw;
      line-height: 1.2em;
    }
    .m-headingForT-more-chars-box1-item--1 {
      width: 90vw;
      height: 19vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box1-img-tablet.png')
          no-repeat right bottom / 59% auto;
      }
      .m-headingForT-more-chars-box1-item__text-wrapper {
        width: 30vw;
      }
    }

    .m-headingForT-more-chars-box1-item--2 {
      width: 90vw;
      height: 19vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box2-img-tablet.png')
          no-repeat right 2vw bottom / 45.5% auto;
      }
      .m-headingForT-more-chars-box1-item__text-wrapper {
        width: 38vw;
      }
    }
    .m-headingForT-more-chars-box1-item--3 {
      width: 44.5vw;
      height: 23vw;
      .m-headingForT-more-chars-box1-item__text-wrapper {
        width: 38vw;
      }
    }
    .m-headingForT-more-chars-box1-item--4 {
      width: 44.5vw;
      height: 23vw;
      .m-headingForT-more-chars-box1-item__text-wrapper {
        width: 38vw;
      }
    }
    .m-headingForT-more-chars-box1-item--5 {
      width: 44.5vw;
      height: 34vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box5-img-tablet.png')
          no-repeat left bottom / 100% auto;
      }
      .m-headingForT-more-chars-box1-item__text-wrapper {
        width: 34vw;
      }
    }
    .m-headingForT-more-chars-box1-item--6 {
      width: 44.5vw;
      height: 34vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box6-img.png')
          no-repeat right -12vw bottom -8vw / 128% auto;
      }
      .m-headingForT-more-chars-box1-item__text-wrapper {
        width: 38vw;
      }
    }
    .m-headingForT-more-chars-box1-item--7 {
      width: 90vw;
      height: 20vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box7-img-tablet.png')
          no-repeat right bottom 0 / 55.3% auto;
      }
      .m-headingForT-more-chars-box1-item__text-wrapper {
        width: 35vw;
      }
    }
    .m-headingForT-more-chars-box1-item--8 {
      width: 90vw;
      height: 20vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box8-img-tablet.png')
          no-repeat right bottom / 35% auto;
      }
      .m-headingForT-more-chars-box1-item__text-wrapper {
        width: 52vw;
      }
    }
    .m-headingForT-more-chars-box1-item--9 {
      width: 90vw;
      height: 20vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box9-img-tablet.png')
          no-repeat right 2.7vw bottom 0 / 53.3% auto;
      }
      .m-headingForT-more-chars-box1-item__text-wrapper {
        width: 35vw;
      }
    }

    .m-headingForT-more-chars-box2 {
      margin-bottom: 22vw;
    }

    .m-headingForT-more-chars-box2__title {
      width: 50vw;
      margin: 0 auto;
    }
    .m-headingForT-more-chars-box2__text {
      width: 80vw;
    }
    .m-headingForT-more-chars-box3__img {
      width: 87vw;
      height: 40vw;
    }

    .m-headingForT-more-chars-box3__text {
      width: 80vw;
      margin: 0 auto 2vw;
    }
  }

  .mobile {
    .m-headingForT-more-chars {
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/bg-mobile.jpg') no-repeat center
        top / 100% auto;
      text-align: center;
      :deep(.m-headingForT-section) {
        padding: 12.7vw 0 0vw;
      }
    }
    .m-headingForT-more-chars-box1 {
      width: 95.3vw;
      height: 720vw;
      padding: 4.4vw 3.5vw;
      margin-bottom: 10vw;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box-bg-mobile.png')
        no-repeat center top / 100% auto;
    }

    .m-headingForT-more-chars-box1 {
    }
    .m-headingForT-more-chars__top-titles {
      width: 80vw;
      margin-bottom: 5vw;
      .m-headingForT__title,
      .m-headingForT__sub-title {
        text-shadow: 2px 2px 4px #191b3d, 2px 2px 4px #191b3d;
      }
    }

    .m-headingForT-more-chars__char--1,
    .m-headingForT-more-chars__char--2,
    .m-headingForT-more-chars__char--3,
    .m-headingForT-more-chars__char--4 {
      display: none;
    }

    .m-headingForT-more-chars-box1 {
      gap: 3vw;
    }

    .m-headingForT-more-chars-box1-item {
      width: 99%;
      height: auto;
      overflow: hidden;
      padding: 3vw 2vw;
      box-shadow: inset 0 0 15px rgba(#80d8ff, 0.4), 0 0 15px rgba(#80d8ff, 0.4);
    }
    .m-headingForT-more-chars-box1-item__text-wrapper {
      width: 90%;
      margin: 0 auto;
      text-align: center;
    }
    .m-headingForT-more-chars-box1-item__title {
      font-size: 5vw;
      line-height: 1.2em;
      margin-bottom: 0.3vw;
    }
    .m-headingForT-more-chars-box1-item__text {
      font-size: 4.5vw;
      line-height: 1.2em;
    }
    .m-headingForT-more-chars-box1-item--1 {
      height: 87vw;
      border-top-left-radius: 0px;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box1-img-mobile.png')
          no-repeat right bottom / 97% auto;
      }
    }
    .m-headingForT-more-chars-box1-item--2 {
      height: 89vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box2-img-tablet.png')
          no-repeat center bottom / 150% auto;
      }
    }
    .m-headingForT-more-chars-box1-item--5 {
      height: 82vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box5-img-tablet.png')
          no-repeat center bottom / 138% auto;
      }
    }
    .m-headingForT-more-chars-box1-item--6 {
      height: 90vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box6-img.png')
          no-repeat left 2.5vw bottom -18vw / 198% auto;
      }
    }
    .m-headingForT-more-chars-box1-item--7 {
      height: 78vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box7-img-tablet.png')
          no-repeat left 2.5vw bottom 3vw /136% auto;
      }
    }
    .m-headingForT-more-chars-box1-item--8 {
      height: 87vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box8-img-mobile.png')
          no-repeat left 2.5vw bottom / 100% auto;
      }
    }
    .m-headingForT-more-chars-box1-item--9 {
      height: 90vw;
      .m-headingForT-more-chars-box1-item__img {
        background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box1-items/box9-img-mobile.png')
          no-repeat left 2.5vw bottom / 100% auto;
      }
    }
    .m-headingForT-more-chars-box2__title,
    .m-headingForT-more-chars-box3 {
      .m-headingForT__title {
        text-shadow: 2px 2px 4px #191b3d, 2px 2px 4px #191b3d;
      }
    }

    .m-headingForT-more-chars-box2__text {
      width: 95%;
    }
    .m-headingForT-more-chars-box3__img {
      width: 102%;
      height: 58vw;
      background: url('~@/assets/images/microsites/headingfortomorrow/more-characters/box3-img.png') no-repeat left
        2.5vw bottom / 132% auto;
    }
  }
</style>
